<script setup lang="ts">
defineOptions({ name: 'AppBottomNavigation' });

const emit = defineEmits<{
    openUserQrScanner: [];
    openLuggageQrScanner: [];
}>();
</script>

<template>
    <v-bottom-navigation grow class="bottom-nav">
        <v-btn to="/admin">
            <v-icon>mdi-home</v-icon>
            <span>TOP</span>
        </v-btn>
        <v-btn @click="emit('openUserQrScanner')">
            <v-icon>mdi-qrcode-scan</v-icon>
            <span>ユーザQR</span>
        </v-btn>
        <v-btn to="/vehicles/select">
            <v-icon>mdi-map-marker-path</v-icon>
            <span>ルート</span>
        </v-btn>
        <v-btn @click="emit('openLuggageQrScanner')">
            <v-icon>mdi-package-variant</v-icon>
            <span>荷物QR</span>
        </v-btn>
    </v-bottom-navigation>
</template>

<style lang="css" scoped>
.bottom-nav {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
}
</style>
